import { css } from "styled-components";
export var setInsideFocusOutline = function setInsideFocusOutline() {
  return css(["outline-offset:-2px;"]);
};
export default setInsideFocusOutline;